import API from 'utils/API'

export const fetchFaq = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/faq${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createFaq = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/faq', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteFaq = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/faq/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchFaqDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/faq/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateFaq = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/faq/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchFaqCategories = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/faq-category${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const createFaqCategory = payload => (
  () => new Promise((resolve, reject) => (
    API.post('/dashboard/faq-category', payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const deleteFaqCategory = id => (
  () => new Promise((resolve, reject) => (
    API.delete(`/dashboard/faq-category/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const fetchFaqCategoryDetail = id => (
  () => new Promise((resolve, reject) => (
    API.get(`/dashboard/faq-category/${id}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const updateFaqCategory = (id, payload) => (
  () => new Promise((resolve, reject) => (
    API.put(`/dashboard/faq-category/${id}`, payload).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const webFetchFaqList = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/web/faq${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)

export const webFetchFaqCategories = params => (
  () => new Promise((resolve, reject) => (
    API.get(`/web/faq-category${params || ''}`).then(
      (response) => {
        const { data, message } = response.data
        if (message === 'OK') {
          resolve(data)
        } else {
          reject(data)
        }
      },
    ).catch((err) => {
      reject(err.message) // eslint-disable-line no-console
    })
  ))
)
